import createHttpClient from './HttpClient'

const httpClient = createHttpClient()

export async function fetchProgressionActivity(slug, { limit = 20, offset = 0 } = {}) {
  const response = await httpClient.get(`/api/v1/characters/${slug}/progression/activity`, {
    params: { limit, offset },
  })
  return response.data
}

export async function fetchProgressionAchievements(slug) {
  const response = await httpClient.get(`/api/v1/characters/${slug}/progression/achievements`)
  return response.data
}

export async function fetchRanks() {
  const response = await httpClient.get('/api/v1/ranks')
  return response.data
}

export async function fetchProgressionRankPath(slug) {
  const response = await httpClient.get(`/api/v1/characters/${slug}/progression/rank-path`)
  return response.data
}
